import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../constants/constants';
import { getValueFromStorage } from '../helpers/helpers';

export const DogsApi = createApi({
  reducerPath: 'dogs',
  tagTypes: ['Dogs', 'Dog'],
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: headers => {
      headers.set('Content-type', 'application/json');
      headers.set('authorization', `Bearer ${getValueFromStorage('token')}`);
      return headers;
    },
  }),
  endpoints: builder => ({
    getDogByUserID: builder.query({
      query: id => ({
        url: `/api/dog/getDogByUserId/${id}`,
        method: 'GET',
      }),
    }),
    getDogByServiceID: builder.query({
      query: id => ({
        url: `/api/dog/getDogByServiceId/${id}`,
        method: 'GET',
      }),
    }),
    getDogByID: builder.query({
      query: id => ({
        url: `/api/dog/getDogById/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'Dog', id }],
    }),
    // Search dogs by name (supports pagination via query params)
    searchDogs: builder.query({
      query: ({
        name = '',
        currentPage = 1,
        resultPerPage = 10,
        vaccinationFilter = 'all',
        medicationFilter = 'all',
        activeFilter = 'all',
      }) => ({
        url: `/api/dog/search`,
        method: 'GET',
        params: {
          name,
          current_page: currentPage,
          result_per_page: resultPerPage,
          vaccination_filter:
            vaccinationFilter === 'expired' ? 'expired' : undefined,
          medication_filter:
            medicationFilter === 'has_medication'
              ? 'has_medication'
              : undefined,
          active_filter:
            activeFilter === 'deleted'
              ? 'deleted'
              : activeFilter === 'active'
                ? 'active'
                : undefined,
        },
      }),
      providesTags: ['Dogs'],
    }),
    updateDog: builder.mutation({
      query: ({ id, body }) => {
        return {
          url: `/api/dog/update/${id}`,
          method: 'PUT',
          body: { dog: body },
        };
      },
      invalidatesTags: (result, error, { id }) => ['Dogs', { type: 'Dog', id }],
    }),
    deleteDog: builder.mutation({
      query: id => ({
        url: `/api/dog/deleteDog/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Dogs'],
    }),
    restoreDog: builder.mutation({
      query: id => ({
        url: `/api/dog/restoreDog/${id}`,
        method: 'PUT',
      }),
      invalidatesTags: (result, error, id) => ['Dogs', { type: 'Dog', id }],
    }),
  }),
});

export const {
  useGetDogByServiceIDQuery,
  useGetDogByUserIDQuery,
  useGetDogByIDQuery,
  useSearchDogsQuery,
  useLazyGetDogByIDQuery,
  useLazyGetDogByServiceIDQuery,
  useLazyGetDogByUserIDQuery,
  useUpdateDogMutation,
  useDeleteDogMutation,
  useRestoreDogMutation,
} = DogsApi;
